/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRevenueInvoicesCtrl
 */
angular.module('mercury.modules.reports.revenue')
.controller('ReportsRevenueAverageCtrl', ["$scope", "ReportSales", "ReportPosStaff", "reporttime", "$stateParams", "$filter", "title", function($scope, ReportSales, ReportPosStaff, reporttime, $stateParams, $filter, title) {
  $scope.salesGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Average Sales', type: 'number', key: 'average', filter: 'currency'}
  ];

  title.set('Average Spend Report');
  $scope.loading = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());

  $scope.loading.then(function(results) {
    angular.forEach(results, function(period) {
      period.average = (period.count !== 0) ? period.invoices / period.count : 0;
    });
    $scope.sales = results;
  });
}]);
